function setInvalidCouponField(errorMessage) {
  $('.promo-code-form .form-control').addClass('invalid -invalid');
  if($('.promo-code-form .form-control').closest('.mm-form-input').length>0){
    $('.promo-code-form .form-control').closest('.mm-form-input').addClass('-invalid');
  }
  $('.coupon-error-message').empty().append(errorMessage);
}

function clearInvalidCouponField() {
  $('.promo-code-form .form-control').removeClass('invalid');
  $('.coupon-error-message').empty();
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.js-subTotal-amount').empty().append(data.totals.subTotal);
  let subTotalContainer = document.querySelector('.sub-total');
  let subTotalSalesContainer = document.querySelector('.js-subTotalList-amount');
  const subTotalAmout = subTotalContainer && subTotalContainer.querySelector('.js-subTotal-amount');
  let subTotalAmountList = subTotalContainer && subTotalContainer.querySelector('.js-subTotalList-amount');
  if (data.totals.subTotalList !== data.totals.subTotal) {

    if (!subTotalSalesContainer) {
      let subTotalListContainer = document.createElement('span');
      subTotalListContainer.className = 'js-subTotalList-amount strike-through';
      subTotalContainer.prepend(subTotalListContainer);
    }

    if(subTotalAmout) {
      subTotalAmout.textContent = data.totals.subTotalSales;
    }

    subTotalAmountList = subTotalContainer && subTotalContainer.querySelector('.js-subTotalList-amount');
    
    if(subTotalAmountList) {
      subTotalAmountList.textContent = data.totals.subTotalList;
    }
    
  } else {

    if(subTotalAmountList){
      subTotalAmountList.textContent = '';
    }
    // subTotalContainer.textContent =data.totals.subTotal;
  }

  $('.shipping-total-cost').empty().append(data.totals.shippingCostAdjusted.formatted);

  if (data.totals.shippingCostAdjusted && data.totals.shippingCostAdjusted.value === 0) {
    $('.shipping-total-cost').addClass('text-green');
  } else {
    $('.shipping-total-cost').removeClass('text-green');
  }

  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.cart-order-discount').removeClass('hide-order-discount');
    $('.order-discount-total')
      .empty()
      .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.cart-order-discount').addClass('hide-order-discount');
  }

  $('.cart-sales-tax .tax-total').empty().append(data.totals.totalTax);
  const $dutiesTotal = $('.cart-duties-tax .tax-total');
  if ($dutiesTotal.length > 0) {
    $dutiesTotal.empty().append(data.totals.duties);
  }
  $('.grand-total').empty().append(data.totals.grandTotal);

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total')
      .empty()
      .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  // Update line items
  data.items.forEach(function (item) {
    $('.item-' + item.UUID)
      .empty()
      .append(item.renderedPromotions);
    $('.item-total-' + item.UUID)
      .empty()
      .append(item.priceTotal.renderedPrice);
    });
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error) {
    if (data.valid.message) {
      let errorHtml =
        '<div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' +
        data.valid.message +
        '</div>';

      $('.cart-error').append(errorHtml);
    }

    $('.checkout-btn').addClass('disabled');
  } else {
    $('.checkout-btn').removeClass('disabled');
  }
}

function addCouponAjax(url) {
  const form = $('.promo-code-form');
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
    data: form.serialize(),
    success: function (data) {
      if (data.error) {
        setInvalidCouponField(data.errorMessage );
        $('.coupon-code-field').addClass('coupon-code-field-error');

        var content = $('.voucher-accordion-content')[0].clientHeight;
        var title = $('#accordion-cart-voucher')[0].clientHeight;
        $('.cart-promo-accordion')[0].style.height = content + title + 'px';
      } else {
        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        updateCartTotals(data);
        // updateApproachingDiscounts(data.approachingDiscounts);
        validateBasket(data);
        $('.coupon-code-field').val('');
        $('.voucher-wrapper').addClass('discounts');
        $('.coupon-code-field').removeClass('coupon-code-field-active');
        $('.voucher-input-container').addClass('input-d-none');

        var content = $('.voucher-accordion-content')[0].clientHeight;
        var title = $('#accordion-cart-voucher')[0].clientHeight;
        $('.cart-promo-accordion')[0].style.height = content + title + 'px';
      }
      $.spinner().stop();
      $('.promo-code-btn').removeClass('button--loading');
    },
    error: function (err) {
      if (err.responseJSON && err.responseJSON.redirectUrl) {
        window.location.href = err.responseJSON.redirectUrl;
      } else {
        $.spinner().stop();

      $('.promo-code-btn').removeClass('button--loading');
      }
    },
  });
}

module.exports = {
  promoCodeFormSubmit: function () {
    $('.promo-code-form').on('submit', function (e) {
      let $form = $('.promo-code-form');
      const appliedCoupon = document.querySelector('.coupons-and-promos .coupon-code');
      e.preventDefault();
      $.spinner().start();
      $('.promo-code-btn').addClass('button--loading');
      clearInvalidCouponField();
      if (!$('.coupon-code-field').val()) {
        setInvalidCouponField($('#couponCode').data('missingError'));
        $.spinner().stop();
        return false;
      }
      if($form.attr('data-one-coupon-only')) {
        if(appliedCoupon) {
          setInvalidCouponField($('.coupon-error-message').data('single-coupon-only'));
        } else {
          addCouponAjax($form.attr('data-coupon-action'));
        }
      } else {
        addCouponAjax($form.attr('action'));
      }
      return false;
    });
  },
  promoCodeFormChange: function () {
    $('.coupon-code-field').on('keyup', function (e) {
      if ($('.coupon-code-field').val().length > 0) {
        $('.coupon-code-field').removeClass('coupon-code-field-error');
        $('.promo-code-btn').removeClass('ab-disabled');
        $('.coupon-code-field').addClass('coupon-code-field-active');
      } else {
        $('.promo-code-btn').addClass('ab-disabled');
        $('.coupon-code-field').removeClass('coupon-code-field-active');
      }
    });
  },

  removeCoupon: function () {
    $('body').on('click', '.remove-coupon', function (event) {
      event.preventDefault();
      const isOneCouponForm = event.target && event.target.closest('form[data-one-coupon-only]');
      const appliedCoupon = document.querySelector('.coupons-and-promos .coupon-code');
      if(isOneCouponForm) {
        if(appliedCoupon) {
          clearInvalidCouponField();
        }
      }

      $.spinner().start();
      $.ajax({
        url: $(this).data('action'),
        type: 'get',
        dataType: 'json',
        success: function (data) {
          $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
          updateCartTotals(data);
          validateBasket(data);
          $.spinner().stop();
          $('.voucher-wrapper').removeClass('discounts');
          $('.voucher-input-container').removeClass('input-d-none');
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            $.spinner().stop();
          }
        },
      });
    });
  },
};
